<div class="textRecordsContainer" style="display: none;">
    <!-- <i *ngIf="bodySpinner" class="fa fa-spinner fa-pulse fa-1x fa-fw"></i>
    <span class="sr-only">Loading...</span> -->
  
    <div class="header hdr">
         <div class="row" id="emailTableSearch">
                <div class="col-3">
        <h5><span class="animateH5">Reports</span></h5>
        </div>
        <div class="col px-0">
       </div>
    </div>

    </div>   

        <div class="container-fluid">
<div style="display: block; max-width:300px;" class="mt-3 ms-3">
    <div class="card">
        <div class="card-header"><label>Status Report</label></div>
        <div class="card-body">
          <p-chart type="pie" [data]="data" [options]="options" class="w-full md:w-[30rem]" />
        </div>
    </div>

    </div>
    </div>
    </div>
    